import useStore from "hooks/useStore";
import { FC, ReactElement } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";

interface Props {
    children: ReactElement
}

const ProtectedRoutes: FC<Props> = ({ children }) => {
    const { getToken, hasAccess, getDefaultPathByRole } = useStore();
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const token = getToken();
    
    // Special handling for mobile subscription route - allow if token is in URL
    const isMobileSubscriptionRoute = pathname === siteRoutes.hostMobileSubscription;
    const tokenInUrl = searchParams.get("token");

    // If this is the mobile subscription route and has a token in URL, allow it to render
    // The component will handle token verification
    if (isMobileSubscriptionRoute && tokenInUrl) {
        return children;
    }

    if (token) {
        if (!hasAccess(pathname)) {
            const defaultPath = getDefaultPathByRole();
            return <Navigate to={defaultPath} />
        }
    } else {
        return <Navigate to={siteRoutes.login} />
    }

    return children;
}

export default ProtectedRoutes;